// Re-export the component and its types
export { EngagementRateSection } from './EngagementRateSection';
export { useEngagementRateProps } from './hooks';
export type { EngagementRateSectionProps } from './hooks';
export type { EngagementRateData } from '@/app/containers/Projects/ProjectsPage/ProspectsList/adapters/member-engagement-rate-adapter';
